// BulkDelete.jsx
import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import TimeEntryDetails from './TimeEntryDetails';

export default function BulkDelete({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .timeAdmin()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={TimeEntryDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('time entry', ids.length)}? This action cannot be undone.`}
    </BulkActionModal>
  );
}
